const TRANSFERVIEW = {
  transferFormsCompany: "Transfer of forms between companies.",
  search: "Search...",
  addDescription: "Add description",
  editTask: "Edit task",
  originCompany: "Company of origin",
  destinityCompany: "Destination company",
  group: "Group",
  toTransfer: "To transfer",
  transfer: "Transfer",
  successTransfer: "The transfer of the form has been carried out.",
  form: "Form",
  typeForm: "Form type",
  group: "Group",
  Active: "Active",
  Closed: "Closed",
  Deleted: "Deleted"
};

export default { TRANSFERVIEW };
